/**
 *  Date    : 2021/11/18
 *  Author  : WeiLin
 *  Declare : 通用常量
 */

// 环境标识
export const ENV = {
  DEV: 'DEV',
  TEST: 'TEST',
  UAT: 'UAT',
  PRO: 'PRO'
};

export const TOKEN = 'TOKEN';

export const PORTAL_ID = {
  BOTTOM: 'PORTAL_BOTTOM',
  BREAD_CRUMB: 'BREAD_CRUMB'
};

export const EMPTY_PAGE_BEAN = {
  recordList: []
};

//表图数据初始值
export const EMPTY_CHART_DATA = {
  values: [[]],
  axis: [],
  axisSort: []
};

/** 各类品牌logo */
export const LOGO = {
  login: 'https://oss.5rs.me/oss/uploadfe/png/f7a73a5235a2fde72918796c3d6bf9eb.png',
  header: 'https://oss.5rs.me/oss/uploadfe/png/c480d755a109a682dc03365ed779b819.png',
  // header: 'https://oss.5rs.me/oss/uploadfe/png/b62999071a1b27e2ac1947b5f3873a38.png',
  modal: 'https://oss.5rs.me/oss/uploadfe/png/644ce96f93060c3953477563290667e5.png'
};

export const EMPTY = 'https://oss.5rs.me/oss/uploadfe/png/717b669fa74f743df05ab077e312282f.png';
export const FAIL = 'https://oss.5rs.me/oss/uploadfe/png/f78604886a7ba9148deb320c8b2689c7.png';
export const DEFAULT_COVER = 'https://oss.5rs.me/oss/uploadfe/png/518d9bb59763556f7373c9a3c7d06eb9.png';
export const CHECKED = 'https://oss.5rs.me/oss/uploadfe/png/d0da0a22d8ec65dd3a7969f9722e97d8.png';

export const NOOP = () => {};   // 无操作，常用于props缺省值
export const JUST_RETURN = _ => _;    // 直接返回
export const RETURN_EMPTY_OBJECT = () => ({});    // 返回空对象，常用于connect传递空的mapStateToProps
export const PREVENT_DEFAULT = event => event.preventDefault();
export const STOP_PROPAGATION = event => event.stopPropagation();

export const FILE_TYPE = {
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  IMAGE: 'IMAGE',
  EXCEL: 'EXCEL',
  PDF: 'PDF',
  WORD: 'WORD',
  PPT: 'PPT',
  ZIP: 'ZIP',
  TXT: 'TXT'
};

export const FORMAT_MAP = (convert = true) => ({
  AUDIO: convert ? ['mp3', 'wav', 'aac', 'wma', 'ape', 'amr'] : ['mp3'],
  VIDEO: convert
    ? ['mp4', 'mkv', 'mpg', 'avi', 'asx', 'mov', 'flv', 'rm', 'wmv', 'rmvb']
    : ['mp4'],
  ALBUM: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'svg', 'webp'],
  PDF: ['pdf'],
  LYRIC: ['lrc'],
  EXCEL: ['csv', 'xls', 'xlsx', 'xlsm', 'xltm', 'xlam'],
  WORD: ['doc', 'docx'],
  PPT: ['ppt', 'pptx'],
  ZIP: ['zip', 'rar'],
  TXT: ['txt']
});

export const FILE_ACCEPT = (needConvert = true) => ({
  PDF: {
    accept: 'application/pdf',
    name: 'PDF',
    tip: ''
  },
  AUDIO: {
    accept: needConvert
      ? 'audio/mp3, audio/wav, audio/aac, audio/x-ms-wma, audio/x-monkeys-audio, audio/amr, audio/mpeg'
      : 'audio/mp3',
    name: '音频',
    tip: needConvert ? '上传的音频将自动转换为mp3格式。' : '音频文件支持MP3格式。'
  },
  VIDEO: {
    accept: needConvert
      ? 'video/mp4, video/x-matroska, video/mpeg, video/x-msvideo, video/quicktime, video/x-flv, application/vnd.rn-realmedia, video/x-ms-wmv, application/octet-stream'
      : 'video/mp4, video/x-matroska',
    name: '视频',
    tip: needConvert ? '上传的视频将自动转换为mp4格式。' : '视频文件支持MP4格式。'
  },
  ALBUM: {
    accept: 'image/png, image/gif, image/jpeg',
    name: '图片',
    tip: ''
  },
  LYRIC: {
    accept: '',
    name: '歌词',
    tip: '歌词文件支持LRC格式。'
  },
  EXCEL: {
    accept:
      'text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    name: 'EXCEL表格',
    tip: '文件格式支持csv、xls、xlsx、xlsm、xltm、xlam格式'
  },
  ZIP: {
    accept: 'application/zip, application/x-rar-compressed',
    name: '压缩文件',
    tip: '压缩文件支持ZIP、RAR格式。'
  },
  'AUDIO-TXT': {
    accept: 'text/plain',
    name: '音频原文',
    tip: '音频原文文件支持TXT格式。'
  },
  WORD: {
    accept:
      'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    name: 'Word文档',
    tip: '文件格式支持doc、docx格式'
  },
  PPT: {
    accept:
      'application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation',
    name: 'PPT文档',
    tip: '文件格式支持ppt、pptx格式'
  },
  EBOOK: {
    accept: 'epub',
    name: '电子书',
    tip: '文件格式支持epub格式'
  },
  PDF_WORD: {
    accept: 'application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    name: 'PDF_WORD',
    tip: '文件格式支持pdf、doc、docx格式'
  }
});

export const DEFAULT_AVATAR = {
  ERROR: '',
  USER: 'https://r.5rs.me/image/920b35ee-4e66-4486-8963-6548279381e1/0cd6b9c35a982fdcd008bbba386c568f.png'
};

/** 文件格式默认图 */
export const FORMAT_COVER_IMG = {
  AUDIO:
      'https://file.5rs.me/oss/uploadfe/jpg/20f5fe72867a4d752929ba81c4034bb6.jpg',
  VIDEO:
      'https://file.5rs.me/oss/uploadfe/jpg/d026cd83cf2ff55e3f4b4493a6919712.jpg',
  TEXT:
      'https://file.5rs.me/oss/uploadfe/jpg/a4b2886d0ca57225f7e7e43cbcfe2638.jpg',
  PDF:
      'https://file.5rs.me/oss/uploadfe/jpg/99042a22bd82ab73affe100c5320e690.jpg',
  WORD:
      'https://file.5rs.me/oss/uploadfe/png/b0669624d5c5533510207849fd105d0a.png',
  EXCEL:
      'https://file.5rs.me/oss/uploadfe/png/a17d1f349398c6835965ac9004eddb09.png',
  PPT:
      'https://file.5rs.me/oss/uploadfe/png/ff1468690c5d1fb7d56b500f0d490426.png',
  COMPRESS:
      'https://file.5rs.me/oss/uploadfe/jpg/027f5a04afb7d7740f681962b7ccc8ef.jpg',
  EBOOK:
      'https://file.5rs.me/oss/uploadfe/jpg/4d5117035b0295f144ef8736ce75aa30.jpg',
  IMAGE:
      'https://file.5rs.me/oss/uploadfe/jpg/f4dc070839a3c6ea256d9c2ea375df25.jpg',
  ARTICLE:
      'https://file.5rs.me/oss/uploadfe/jpg/8bdd5c68c7cc6f621dd0bc119c89d63f.jpg',
  OTHER:
      'https://file.5rs.me/oss/uploadfe/jpg/1d0a9710e11408c632f4e372afcd49ba.jpg'

};

export const COLOR = {
  /** 主色调 */
  PRIMARY: '#006AFF'
};

export const FAKE_USER = {
  user: 'https://oss.raysgo.com/oss/uploadfe/webp/27b44f27ac20fdb9c14e77436c1fd666.webp',
  ai: 'https://oss.5rs.me/oss/spider/other/jpg/307669FFD3EB7175982650FCF8FBA0A7.jpg',
  rays: 'https://oss.5rs.me/oss/uploadfe/png/164535431651db226b69bbe4b7e58ffd.png'
};

/** 常用第三方LOGO */
export const OTHOR_LOGOS = {
  /** 微信 */
  wechat: 'https://oss.5rs.me/oss/uploadfe/png/597ca0f3d0431d3b9573a7b99d8450b9.png',
  /** 小红书 */
  xiaohongshu: 'https://oss.5rs.me/oss/uploadfe/png/834b598675823dc5183e413bdf699f25.png',
  /** 封面/腰封 */
  cover: 'https://oss.5rs.me/oss/uploadfe/png/84be0b5cc6478fe98b8804f227484016.png',
  /** 豆瓣 */
  douban: 'https://oss.5rs.me/oss/uploadfe/png/1290a2fd31efdb9a2ae590c7152af1f8.png',
  /** 短视频 */
  video: 'https://oss.5rs.me/oss/uploadfe/png/53c7967427566bc4e7f5573af3d671f1.png',
  /** 直播 */
  live: 'https://oss.5rs.me/oss/uploadfe/png/6e8f5a00cd9b59ea5334791b18360059.png',
  /** 朋友圈 */
  pengyouquan: 'https://oss.5rs.me/oss/uploadfe/png/7ede8699cec32cf1b8797f3a90e63f76.png',
  /** 爆款 */
  hot: 'https://oss.5rs.me/oss/uploadfe/png/c9696be7fc25d3b1ef26c41788833a73.png'
};

/** 支付状态 */
export const PAY_STATUS = {
  ORDER: {
    value: -2,
    label: ''
  },
  REFUND: {
    value: -1,
    label: '已退款'
  },
  CANCEL: {
    value: 0,
    label: '已取消'
  },
  /** 支付中，出现二维码 */
  PAYMENT: {
    value: 1,
    label: '待支付'
  },
  /** 支付成功 */
  SUCCESS: {
    value: 5,
    label: '已支付'
  }
};
/**页面固定最小宽度 */
export const SCREEN_WIDTH = {
  /**移动端最小宽度 */
  MOBILEWDITH: 990,
  /**PC端最小宽度 */
  PCWIDTH: 1280
};